import { checkFetchStatus, NetworkError, parseResponseAsJson } from '../lib/fetch';
import pRetry from 'p-retry';

/**
 * Method used for all auth requests. Executes a fetch request with the given url and request options.
 * Ensures that we include the correct headers and credentials configuration.
 * Retries on any network failure (5XX status codes)
 * @param url The url to fetch
 * @param req  The request options. Compatible with the fetch API.
 * @param parse Whether to parse the response as JSON. Defaults to true.
 * @param retries Number of allowed retries for 5XX failures
 * @throws {NetworkError}
 */
export class RequestUtil {
  public static request(url: string, req: RequestInit, parse = true, retries = 3) {
    const request = async () =>
      await fetch(url, {
        headers: { ...req.headers },
        credentials: 'include',
        ...req,
      }).then(parse ? parseResponseAsJson : checkFetchStatus);

    return pRetry(request, {
      shouldRetry: (error) => error instanceof NetworkError && error.status >= 500,
      retries,
    });
  }
}
